import React, { useCallback } from 'react'
import {
  CloudAccountSelector,
  CloudAccountType,
} from '@labrav/react-components'
import { SelectChangeEvent } from '@mui/material'

import type { CloudMarketplace } from '../../types/marketplace'

export type CloudAccountChangeParams = {
  accountId: string
  cloud: CloudMarketplace
  provider: string
}

interface CloudAccountChangeV2Props {
  cloudAccounts: CloudAccountType[]
  selectedAccountId: string
  onChange: (params: CloudAccountChangeParams) => void
  width?: number
  size?: 'small' | 'medium'
  disabled?: boolean
}

export const CloudAccountChangeV2: React.FC<CloudAccountChangeV2Props> = ({
  cloudAccounts,
  selectedAccountId,
  onChange,
  width = 220,
  size = 'small',
  disabled = false,
}) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent<string>) => {
      const nextAccountId = event.target.value as string
      const selectedAccount = cloudAccounts.find(
        account => account.id === nextAccountId
      )

      if (!selectedAccount) return

      onChange({
        accountId: nextAccountId,
        cloud: selectedAccount.provider as CloudMarketplace,
        provider: selectedAccount.provider,
      })
    },
    [cloudAccounts, onChange]
  )

  return (
    <CloudAccountSelector
      cloudAccounts={cloudAccounts}
      label="Cloud account"
      selectedAccountId={selectedAccountId}
      onChange={handleChange}
      width={width}
      size={size}
      disabled={disabled}
    />
  )
}
